import PropTypes from 'prop-types'

import { Banner } from '@loadsmart/loadsmart-ui'

import { I18n } from 'legacy/components/I18n/i18n'

function RMISCompleteBanner(props) {
  const { onClose } = props
  return (
    <Banner
      title={I18n.get('lb.RMIS.onboardingBanner.completed')}
      variant="success"
      scale="default"
      onClose={onClose}
    />
  )
}

RMISCompleteBanner.propTypes = {
  onClose: PropTypes.func,
}

RMISCompleteBanner.defaultProps = {
  onClose: () => {},
}

export { RMISCompleteBanner }
